var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("icons/pills/pill-crashboxx copy@1x")]),
      _vm._v(" "),
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points:
              "0.950865958 0.736 4.00556792 0.736 4.00556792 13.721 0.950865958 13.721"
          }
        }),
        _vm._v(" "),
        _c("polygon", {
          attrs: {
            id: "path-3",
            points: "0 0.2581 39.7426 0.2581 39.7426 36 0 36"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-1069.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(1069.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 1.42108547e-14,99.2637914 1.42108547e-14,90.9548646 L1.42108547e-14,15.0451354 C1.42108547e-14,6.73520562 6.78532554,7.10542736e-15 15.1548367,7.10542736e-15 L90.8451633,7.10542736e-15 C99.2146745,7.10542736e-15 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#AF6DAA"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-25",
                        transform: "translate(18.000000, 25.000000)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M49.7111,34.6305 C50.8831,35.1215 52.2351,34.5685 52.7271,33.3975 C53.2181,32.2255 52.6651,30.8725 51.4941,30.3805 L47.8931,28.8705 C46.7221,28.3795 45.3681,28.9325 44.8771,30.1045 C44.3851,31.2755 44.9391,32.6295 46.1111,33.1205 L49.7111,34.6305 Z",
                          id: "Fill-1",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M43.1584,7.1444 C43.6214,6.6834 43.7424,6.2964 43.3414,5.9854 L42.8744,5.6994 L42.4084,5.4134 C42.2494,5.3254 42.1844,5.2354 42.1014,5.2274 C41.8614,5.2044 41.5054,5.4124 41.3834,5.8214 L37.2744,13.5054 L43.1584,7.1444 Z",
                          id: "Fill-3",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group-7",
                            transform: "translate(34.000000, 0.264300)"
                          }
                        },
                        [
                          _c(
                            "mask",
                            { attrs: { id: "mask-2", fill: "white" } },
                            [_c("use", { attrs: { "xlink:href": "#path-1" } })]
                          ),
                          _vm._v(" "),
                          _c("g", { attrs: { id: "Clip-6" } }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M3.9075,2.341 C4.1405,1.543 3.9555,0.949 3.3825,0.895 L2.6435,0.825 L1.7485,0.74 C1.1775,0.686 0.8905,1.151 0.9615,2.062 L1.3505,13.721 L3.9075,2.341 Z",
                              id: "Fill-5",
                              fill: "#FFFFFF",
                              mask: "url(#mask-2)"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M33.5425,13.8886 L30.9485,5.5686 C30.8325,5.1376 30.5945,4.8726 30.3555,4.8506 L30.1155,4.8276 C30.0325,4.8196 30.0245,4.9036 29.9515,4.8966 L29.4405,5.0896 L28.9935,5.3726 C28.5555,5.5726 28.6095,5.9986 28.9685,6.5246 L33.5425,13.8886 Z",
                          id: "Fill-8",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M62.3689,26.4763 L43.0639,18.3793 L47.2289,13.6023 C47.6839,13.0873 48.4149,12.9193 49.0529,13.1873 L61.9639,18.6003 C62.5989,18.8663 62.9909,19.5053 62.9409,20.1853 L62.3689,26.4763 Z M66.8449,28.6623 L67.4309,20.4933 C67.5799,17.8723 66.0549,15.4283 63.6139,14.4033 L50.7769,9.0193 C48.3539,8.0033 45.5419,8.6283 43.7759,10.5773 L38.3849,16.7183 C37.1939,16.5863 36.0309,16.8223 35.0009,17.3223 C35.0639,17.4733 35.1279,17.6243 35.1839,17.7813 L36.5369,21.7893 C36.9799,21.3063 37.6919,21.1233 38.3309,21.3913 L63.5309,31.9613 C64.3439,32.3023 64.7279,33.2413 64.3869,34.0543 L61.3669,41.2553 C61.0259,42.0683 60.0869,42.4523 59.2729,42.1113 L42.3819,35.0263 L42.3819,40.0233 L55.3649,45.4693 L54.7469,46.9443 C54.2559,48.1163 54.8089,49.4693 55.9799,49.9613 C57.1519,50.4523 58.5049,49.8983 58.9969,48.7263 L59.7929,46.8273 C62.3109,46.8703 64.6289,45.3713 65.6159,43.0373 L68.6369,35.8353 C69.6859,33.3073 68.9469,30.3893 66.8449,28.6623 L66.8449,28.6623 Z",
                          id: "Fill-10",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M39.8298,25.6821 C39.6628,25.6731 39.4988,25.6881 39.3388,25.7171 C40.4108,26.6591 41.2358,27.8521 41.7578,29.1831 C41.8218,29.0801 41.8848,28.9751 41.9288,28.8621 C42.1558,28.2981 42.1608,27.6751 41.9398,27.0981 C41.5878,26.2511 40.6948,25.6781 39.8298,25.6821",
                          id: "Fill-12",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M21.824,33.9437 L17.92,33.9437 C16.65,33.9437 15.615,34.9777 15.615,36.2487 C15.615,37.5187 16.65,38.5517 17.92,38.5517 L21.824,38.5517 C23.094,38.5517 24.128,37.5187 24.128,36.2487 C24.128,34.9777 23.094,33.9437 21.824,33.9437",
                          id: "Fill-14",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M28.7705,34.1224 C28.1795,34.3354 27.7185,34.7964 27.5095,35.3754 C27.2805,35.9464 27.2875,36.5734 27.5305,37.1384 C27.7725,37.7044 28.2205,38.1424 28.7915,38.3714 C29.0655,38.4804 29.3525,38.5354 29.6475,38.5354 C29.9425,38.5354 30.2305,38.4804 30.4915,38.3754 C31.0825,38.1614 31.5445,37.7004 31.7465,37.1394 C31.8775,36.8594 31.9425,36.5484 31.9345,36.2444 C31.9265,35.6364 31.6915,35.0594 31.2655,34.6114 C30.6095,33.9664 29.5655,33.7844 28.7705,34.1224",
                          id: "Fill-16",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group-20",
                            transform: "translate(0.000000, 14.264300)"
                          }
                        },
                        [
                          _c(
                            "mask",
                            { attrs: { id: "mask-4", fill: "white" } },
                            [_c("use", { attrs: { "xlink:href": "#path-3" } })]
                          ),
                          _vm._v(" "),
                          _c("g", { attrs: { id: "Clip-19" } }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M35.1346,25.8881 C35.1346,26.7701 34.4176,27.4871 33.5356,27.4871 L6.2086,27.4871 C5.3266,27.4871 4.6086,26.7701 4.6086,25.8881 L4.6086,18.0801 C4.6086,17.1981 5.3266,16.4811 6.2086,16.4811 L33.5356,16.4811 C34.4176,16.4811 35.1346,17.1981 35.1346,18.0801 L35.1346,25.8881 Z M11.4016,5.8561 C11.6206,5.2061 12.2296,4.7681 12.9226,4.7681 L26.9226,4.7661 C27.6106,4.7661 28.2196,5.2031 28.4366,5.8501 L30.3426,11.8721 L9.4086,11.8721 L11.4016,5.8561 Z M35.3146,12.1561 L32.6956,4.3961 C31.8196,1.9221 29.4676,0.2581 26.8206,0.2581 L12.8996,0.2581 C10.2736,0.2581 7.9216,1.9221 7.0466,4.4021 L4.4506,12.1501 C1.8326,12.9231 0.0116,15.3331 -0.0004,18.0801 L-0.0004,25.8891 C0.0076,28.4231 1.5656,30.7011 3.9036,31.6351 L3.9036,33.6951 C3.9036,34.9661 4.9386,36.0001 6.2086,36.0001 C7.4786,36.0001 8.5126,34.9661 8.5126,33.6951 L8.5126,32.0961 L31.2306,32.0961 L31.2306,33.6951 C31.2306,34.9661 32.2646,36.0001 33.5356,36.0001 C34.8056,36.0001 35.8386,34.9661 35.8386,33.6951 L35.8386,31.6351 C38.1776,30.7011 39.7356,28.4221 39.7426,25.8881 L39.7426,18.0781 C39.7316,15.3411 37.9216,12.9351 35.3146,12.1561 L35.3146,12.1561 Z",
                              id: "Fill-18",
                              fill: "#FFFFFF",
                              mask: "url(#mask-4)"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M57.7728,37.8203 C58.4008,37.8513 59.0048,37.6043 59.4078,37.1653 C59.6368,36.9583 59.8178,36.6963 59.9278,36.4133 C60.1548,35.8503 60.1608,35.2263 59.9418,34.6483 C59.5868,33.8003 58.6938,33.2283 57.8308,33.2323 C57.2028,33.2003 56.5988,33.4473 56.1828,33.9003 C55.7508,34.3383 55.5158,34.9193 55.5198,35.5343 C55.5248,36.1493 55.7688,36.7273 56.2068,37.1583 C56.4158,37.3653 56.6608,37.5283 56.9318,37.6413 C57.2038,37.7553 57.4908,37.8163 57.7728,37.8203",
                          id: "Fill-21",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M9.2503,34.1224 C8.6603,34.3354 8.1993,34.7954 7.9893,35.3754 C7.5173,36.5554 8.0933,37.8984 9.2723,38.3714 C9.5453,38.4804 9.8333,38.5354 10.1283,38.5354 C10.4223,38.5354 10.7103,38.4804 10.9903,38.3684 C11.2653,38.2534 11.5153,38.0934 11.7563,37.8714 C11.9583,37.6514 12.1183,37.4004 12.2263,37.1394 C12.3583,36.8604 12.4233,36.5494 12.4163,36.2434 C12.4073,35.6354 12.1713,35.0584 11.7443,34.6124 C11.0923,33.9674 10.0463,33.7844 9.2503,34.1224",
                          id: "Fill-23",
                          fill: "#FFFFFF"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }